var exports = {
  "x": "ClientInfo.module__button___Ul9OTE",
};

module.exports = exports;
